import * as React from 'react';
import styles from './styles.module.css'; 
import clsx from 'clsx';
interface ScoreDisplayProps {
    label : string
    value : string
}
export const ScoreDisplay: React.FC<ScoreDisplayProps> = ({ label, value }) => {
  return (
    <div className={styles.scoreContainer}>
      <p className={clsx(styles.scoreLabel , "fontSizeSm12 fontWeightMedium")}>{label}</p>
      <p className={clsx(styles.scoreValue, "fontSizeSm18 fontWeightBold")}>{value}</p>
    </div>
  );
};